export default __webpack_public_path__ + "static/media/AUTORES_06.fc239121.png";